module.exports = __webpack_public_path__ + "img/swine-company-name.a3b85aa4.png";